import { useState } from 'react';
// components
import SkeletonNoData from 'src/components/skeleton/SkeletonNoData';
import { NoSignUpsPlaceholder } from 'src/components/chart/NoDataPlaceholder';
import SimpleStatsTile from 'src/components/reporting/SimpleStatsTile';

// ----------------------------------------------------------------------

interface Props {
  dataset: any;
  isLoading: boolean;
  link?: string;
  text?: string;
  hidePlaceholder?: boolean;
}

const Summary: React.FC<Props> = ({ dataset, isLoading, link, text, hidePlaceholder }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = (text: string) => {
    const copyTextToClipboard = async (text: any) => {
      if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(text);
      }
    };

    copyTextToClipboard(text)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1500);
      })
      .catch((err) => console.error(err));
  };

  return (
      <SkeletonNoData
        isLoading={isLoading}
        hasData={dataset?.totalOffsets > 0}
        height={260}
        text={hidePlaceholder && text ? text : ''}
        Placeholder={!hidePlaceholder ? () => (
          <NoSignUpsPlaceholder
            invitationLink={link}
            onCopy={handleCopyClick}
            isCopied={isCopied}
            title={'No offsets yet'}
            text={text || `Get started and invite your customers to join with the programme's signup link`}
          />
        ) : null}
        hideInfo
      >
        {dataset && <SimpleStatsTile data={dataset} />}
      </SkeletonNoData>
  );
};

export default Summary;
